import React, { useState, useEffect } from "react";
import axios from "axios";
import urldata from "../../../../urldata";

import Button from "../../../../component/Button/Button";
import { Col, Row } from "react-bootstrap";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";
import Imageurldata from "../../../../Imageurldata";

const CareerBanner = () => {
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [titleErr, setTitleErr] = useState("");

  const [mobImg, setMobImg] = useState("");
  const [mobImgErr, setMobImgErr] = useState("");
  const [showMobImg, setShowMobImg] = useState(false);
  const [checkMobileImgPresent, setCheckMobileImgPresent] = useState(false);

  const [desktopImg, setDesktopImg] = useState("");
  const [desktopImgErr, setDesktopImgErr] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState(false);
  const [checkDesktopImgPresent, setCheckDesktopImgPresent] = useState(false);
  const [mobPreview, setMobPreview] = useState("");
  const [desktopPreview, setDesktopPreview] = useState("");

  const [toastlist, setToastList] = useState([]);

  let toastProperties = null;

  const allowedExtensions = [
    "jpg",
    "jpeg",
    "png",
    "svg",
    "JPG",
    "JPEG",
    "PNG",
    "SVG",
  ];

  // Validate image type
  const validateImage = (file) => {
    if (!file) return false;
    const ext = file.name.split(".").pop();
    return allowedExtensions.includes(ext);
  };

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: "Banner Saved Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      case "danger":
        toastProperties = {
          id,
          title: "Error",
          description: "Something went wrong",
          backgroundColor: "red",
          icon: close,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const fetchCareerBanner = () => {
    setLoading(true);

    axios({
      method: "get",
      url: urldata + "admin/getCareerBanner",
      withCredentials: true,
    })
      .then((response) => {
        const data = response.data.data[0];

        setTitle(data?.title || "");

        setMobImg(data?.mobImg ? Imageurldata + data.mobImg : "");
        setMobPreview(data?.mobImg ? Imageurldata + data.mobImg : "");
        setShowMobImg(false);
        setCheckMobileImgPresent(false);

        setDesktopImg(data?.banImg ? Imageurldata + data.banImg : "");
        setDesktopPreview(data?.banImg ? Imageurldata + data.banImg : "");
        setShowDesktopImg(false);
        setCheckDesktopImgPresent(false);

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCareerBanner();
  }, []);

  const addBannerData = () => {
    let formData = new FormData();

    formData.append("title", title);

    if (checkDesktopImgPresent) {
      formData.append("bannerImageWeb", desktopImg);
      setCheckDesktopImgPresent(false);
    }

    if (checkMobileImgPresent) {
      formData.append("bannerImageMobile", mobImg);
      setCheckMobileImgPresent(false);
    }

    let url = new URL(urldata + "admin/addCareerBanner");
    let finalUrl = decodeURIComponent(url);

    setLoading(true);
    axios({
      method: "post",
      url: finalUrl,
      data: formData,
      withCredentials: true,
    })
      .then(() => {
        setLoading(false);
        showToast("success");

        fetchCareerBanner();

        setTitle("");
        setMobImg("");
        setDesktopImg("");
        setShowMobImg(false);
        setShowDesktopImg(false);
      })
      .catch(() => {
        setLoading(false);
        showToast("danger");
      });
  };

  const submit = () => {
    let valid = true;

    if (!title) {
      valid = false;
      setTitleErr("*Please enter Title");
    } else setTitleErr("");

    if (!mobImg) {
      valid = false;
      setMobImgErr("*Please upload Mobile Banner");
    } else setMobImgErr("");

    if (!desktopImg) {
      valid = false;
      setDesktopImgErr("*Please upload Desktop Banner");
    } else setDesktopImgErr("");

    if (valid) addBannerData();
  };

  return (
    <>
      <h1>Career Banner</h1>
      <br />

      <Row className="adminhomeaboutSec1">
        {/* Title */}
        <Col lg={3} className="column">
          <div className="title">Title:</div>
        </Col>

        <Col lg={9} className="column">
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            type="text"
          />

          <div className="fileTxt">Use &lt;br /&gt; tag for line break.</div>

          <h4 className="err">{titleErr}</h4>
        </Col>

        {/* Mobile Image */}
        <Col lg={3} className="column">
          <div className="title">Mobile Image:</div>
          <div className="desc">Size: 375 × 812</div>
        </Col>

        <Col lg={9} className="column">
          <input
            id="mobImage"
            accept=".jpg,.jpeg,.png,.svg"
            type="file"
            onChange={(e) => {
              const file = e.target.files[0];
              setMobImg(file);
              setMobPreview(URL.createObjectURL(file));

              if (!validateImage(file)) {
                setMobImgErr("Invalid file! Only JPG, PNG, SVG allowed.");
                return;
              }

              setMobImg(file);
              setMobImgErr("");
              setShowMobImg(true);
              setCheckMobileImgPresent(true);
            }}
          />

          <label htmlFor="mobImage" className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>

          <div className="fileTxt">File Format: JPG / JPEG / PNG / SVG</div>
          <div className="err">{mobImgErr}</div>

          {mobPreview && (
            <img
              src={mobPreview}
              alt="Mobile preview"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                marginTop: "10px",
              }}
            />
          )}
        </Col>

        {/* Desktop Image */}
        <Col lg={3} className="column">
          <div className="title">Desktop Image:</div>
          <div className="desc">Size: 1920 × 726</div>
        </Col>

        <Col lg={9} className="column">
          <input
            id="desktopImage"
            accept=".jpg,.jpeg,.png,.svg"
            type="file"
            // Desktop Image onChange - FIXED
            onChange={(e) => {
              const file = e.target.files[0];

              if (!file) return;

              if (!validateImage(file)) {
                setDesktopImgErr("Invalid file! Only JPG, PNG, SVG allowed.");
                return;
              }

              setDesktopImg(file);
              setDesktopPreview(URL.createObjectURL(file)); // This was missing/wrong!
              setDesktopImgErr("");
              setShowDesktopImg(true);
              setCheckDesktopImgPresent(true);
            }}
          />

          <label htmlFor="desktopImage" className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>

          <div className="fileTxt">File Format: JPG / JPEG / PNG / SVG</div>
          <div className="err">{desktopImgErr}</div>

          {desktopPreview && (
            <img
              src={desktopPreview}
              alt="Desktop preview"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                marginTop: "10px",
              }}
            />
          )}
        </Col>

        <Col className="column d-f j-c a-c">
          <Button onClick={submit} title="SUBMIT" />
        </Col>
      </Row>

      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default CareerBanner;
